export class ConeDeRisco {
    constructor(
        public pronta_resposta = 0,
        public roubos_label = 0,
        public acidentes_label = 0,

        public alertas = 0,
        public tratamento = 0,
        public tratamento_formatted = "",
        public eventos = 0,
        public eventos_formatted = "",
        public calculo_sucesso = 0,
        public sucesso_formatted = 0,

        public sem_nc = 0,
        public sem_nc_formatted = "",
        public percentual_cto = 0,

        public total_viagens = 0,
        public ids_total_viagens = '',
        public cto = 0,
        public ids_cto = '',
        public nc = 0,
        public ids_nc = '',
        public ocorrencias = 0,
        public ids_ocorrencias = '',
        public ratc = 0,
        public ids_ratc = '',
        public acidente = 0,
        public ids_acidente = '',
        public roubo = 0,
        public ids_roubo = '',
        public perdas = 0,
        public ids_perdas = '',
        public status_agendada = 0,
        public ids_status_agendada = '',
        public status_preenchida = 0,
        public ids_status_preenchida = '',
        public status_rascunho = 0,
        public ids_status_rascunho = '',
        public status_ag_conf = 0,
        public ids_status_ag_conf = '',
        public status_ag_check = 0,
        public ids_status_ag_check = '',
        public status_ag_aprov = 0,
        public ids_status_ag_aprov = '',
        public status_ag_inicio = 0,
        public ids_status_ag_inicio = '',
        public status_em_viagem = 0,
        public ids_status_em_viagem = '',
        public risco_m_baixo = 0,
        public ids_risco_m_baixo = '',
        public risco_baixo = 0,
        public ids_risco_baixo = '',
        public risco_medio = 0,
        public ids_risco_medio = '',
        public risco_alto = 0,
        public ids_risco_alto = '',
        public risco_escolta_eletronica = 0,
        public ids_risco_escolta_eletronica = '',
        public risco_n_informado = 0,
        public ids_risco_n_informado = '',
        public finalizadas_dia = 0,
        public ids_finalizadas_dia = '',
        public finalizadas_hora = 0,
        public ids_finalizadas_hora = '',
        public programadas_dia = 0,
        public ids_programadas_dia = '',
        public programadas_hora = 0,
        public ids_programadas_hora = '',
        public ids_alertas = '',
        public usar_regra_alertas = false,
    ) {
    }
}